import {
  Flex,
  Alert,
  AlertIcon,
  Link,
  AlertDescription,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useGetCountOfUnmatchedLimitedPartnerMappingsQuery } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const AliasMatchingAlert = () => {
  const {
    user: { organizationId },
  } = useUserAuthOrThrow();

  const {
    data: unmatchedCountData,
    error: unmatchedCountDataError,
  } = useGetCountOfUnmatchedLimitedPartnerMappingsQuery({
    variables: {
      lenderOrganizationId: organizationId,
    },
    fetchPolicy: 'cache-and-network',
  });

  if (unmatchedCountDataError) throw unmatchedCountDataError;
  if (
    !unmatchedCountData ||
    unmatchedCountData.unmatchedLimitedPartnerMappingsCount === 0
  ) {
    return null;
  }

  const unmatchedCount =
    unmatchedCountData.unmatchedLimitedPartnerMappingsCount;
  return (
    <Alert status="warning" mb="2rem" borderRadius="6px">
      <AlertIcon />
      <AlertDescription width="100%">
        <Flex justifyContent="space-between" alignItems="center">
          <Typography fontWeight="semibold">
            {unmatchedCount} LP Alias
            {unmatchedCount === 1 ? ' was ' : 'es were '}
            not found in database.
          </Typography>
          <Link
            as={RouterLink}
            fontSize="sm"
            fontWeight="bold"
            color="blue.400"
            to="/limited-partners/alias-matching"
            _hover={{
              textDecoration: 'underline',
            }}
          >
            Match LP Aliases
          </Link>
        </Flex>
      </AlertDescription>
    </Alert>
  );
};
